import { Component, ViewChild, ElementRef } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FormControl, Validators } from '@angular/forms';

@Component({
    selector: 'dialog-create-room',
    templateUrl: './createRoom.html',
    styleUrls: ['./createRoom.scss'],
  })
  
  export class DialogCreateRoom {
    public text: string;
  
    constructor(public dialogRef: MatDialogRef<DialogCreateRoom>) {
    }
  }